import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './Button';
import RecordingButton from './RecordingButton';

export interface LiveClassListItemProps {
  name: string;
  dateTime: string;
  dateTimeLabel: string;
  hasFeedback: boolean;
  feedback: string | null;
  onFeedbackClick?: () => void;
  recordingUrl?: string | null | undefined;
  surveyUrl?: string | null | undefined;
}

const LiveClassListItem: FC<LiveClassListItemProps> = (props) => {
  const __ = useTranslation().t;
  const ReportButton = () => (
    <Button
      icon="file-alt"
      label={__('seeReport')}
      onClick={props.onFeedbackClick}
      disabled={!props.hasFeedback}
      outline
      size="sm"
      variant="primary"
      className="nowrap"
    />
  );

  const SurveyButton = () => (
    <Button
      label={__('completeSurvey')}
      onClick={() => {}}
      variant="subtle"
      className="oejr-lc-survey-button"
      size="sm"
      href={props.surveyUrl || undefined}
      disabled={!props.surveyUrl}
      target="_blank"
    />
  );

  const RecButton = ({ size }: { size: 'sm' | 'md' }) => (
    <RecordingButton
      onClick={() => props.recordingUrl && window.open(props.recordingUrl)}
      disabled={!props.recordingUrl}
      size={size}
    />
  );

  return (
    <div className="oejr-lc-list-item">
      <div className="oejr-lc-name">
        <p>{props.name}</p>
      </div>
      <div className="oejr-lc-date-time">
        <p>{props.dateTimeLabel}</p>
        <RecButton size="sm" />
      </div>
      <div className="oejr-lc-buttons">
        <div className="oejr-lc-report">
          <ReportButton />
        </div>
        <div className="oejr-lc-recording">
          <RecButton size="md" />
        </div>
        <div className="oejr-lc-survey">
          <SurveyButton />
        </div>
      </div>
    </div>
  );
};

export default LiveClassListItem;
